import type { AdminGetLiquidityAccountsParams } from '../api'
import { api } from '../api'

const adminGetLiquidityAccounts = async (
  data: AdminGetLiquidityAccountsParams,
) => {
  return await api.v1.adminGetLiquidityAccounts(data)
}

export default {
  adminGetLiquidityAccounts,
}
